export default __webpack_public_path__ + "static/media/TAS_Accepted.4bc3cbdf.png";